import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import o, { useContext as c } from "react";
import { PrimaryNavContext as m } from "./PrimaryNavContext";

var l = function l() {
  var t, a, s;

  var _c = c(m),
      r = _c.menuData,
      i = _c.loginAction,
      n = (t = r == null ? void 0 : r.userActions) == null ? void 0 : t.find(function (e) {
    return e.name === "log-in";
  });

  return o.createElement("div", {
    className: "hg-primarynav__useractions"
  }, o.createElement("h2", {
    className: "hg-primarynav__menu-header"
  }, "My account"), o.createElement("a", {
    href: (a = n == null ? void 0 : n.url) != null ? a : "/authenticate/signin",
    className: "hg-primarynav__useractions-button",
    id: "useractionslogin-button",
    onClick: i
  }, (s = n == null ? void 0 : n.label) != null ? s : "Log in"));
};

export { l as UserActionsLogin };